import React from "react";
import { Link } from "react-router-dom";

export default function Sidebar() {
  const menu = [
    { label: "Trang Chủ", to: "/" },
    { label: "Khóa Học", to: "/topic" },
    { label: "Thi Đấu", to: "/competition", badge: "New" },
    { label: "Phương Pháp", to: "/method" },
    { label: "Cách Học Chi Tiết", to: "/how" },
    { label: "Hướng Dẫn Tải App", to: "/download" },
    { label: "Bảng Giá", to: "/pricing" },
    { label: "Blog", to: "/blog" },
    { label: "Liên Hệ", to: "/contact" },
  ];

  return (
    <aside className="hidden md:block w-64 bg-[#f0f7fb] h-screen sticky top-0 shadow-inner">
      <div className="px-4 py-6">
        <h3 className="text-lg font-bold text-[#1e90ff]">VuaLingo</h3>
      </div>
      <nav className="px-2">
        <ul className="space-y-2">
          {menu.map((m) => (
            <li key={m.to}>
              <Link
                to={m.to}
                className="flex items-center justify-between px-4 py-3 rounded-lg text-gray-800 hover:bg-white hover:shadow"
              >
                <span>{m.label}</span>
                {m.badge && (
                  <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">{m.badge}</span>
                )}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
